'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    font-size: 12px;\n    height: 24px;\n  '], ['\n    font-size: 12px;\n    height: 24px;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    font-size: 12px;\n    height: 32px;\n  '], ['\n    font-size: 12px;\n    height: 32px;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    font-size: 14px;\n    height: 40px;\n  '], ['\n    font-size: 14px;\n    height: 40px;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  border-bottom: 2px solid ', ';\n  ', ';\n'], ['\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  border-bottom: 2px solid ', ';\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors


var sizes = {
  small: (0, _styledComponents.css)(_templateObject),
  normal: (0, _styledComponents.css)(_templateObject2),
  large: (0, _styledComponents.css)(_templateObject3)
};

var TextContainer = _styledComponents2.default.div(_templateObject4, _colors.grey, function (_ref) {
  var size = _ref.size;
  return sizes[size];
});

exports.default = TextContainer;